import {
  getCloseRobot,
  getIndex,
  getOpenRobot,
  getRobotInfo
} from '@/server/robot'

function selectExchangeServer(robotType) {
  getIndex(Number(robotType) === 0 ? 1 : 2)
}

function ensureSuccess(result, fallback) {
  if (!result || result.success === false) {
    throw new Error((result && result.message) || fallback)
  }
  return result
}

export async function loadRobotPowerState(robotType) {
  selectExchangeServer(robotType)
  const result = ensureSuccess(
    await getRobotInfo(Number(robotType)),
    '机器人状态读取失败'
  )
  return result.data || {}
}

export async function executeRobotPower(robotType, currentState) {
  const numericRobotType = Number(robotType)
  selectExchangeServer(numericRobotType)
  if (Number(currentState) === 1) {
    return {
      action: 'close',
      result: await getCloseRobot(numericRobotType)
    }
  }
  if (Number(currentState) === 2) {
    return {
      action: 'open',
      result: await getOpenRobot(numericRobotType)
    }
  }
  throw new Error('当前机器人状态不允许启动或关闭')
}
